export interface Icgi {
	active: boolean;
	createdAt: Date;
	description: string;
	id: number;
	isBaseline: boolean;
	lastAnswer: cgiOption;
	mustHaveCrm: boolean;
	mustHaveCrp: boolean;
	nextFromId: string | null;
	options: cgiOption[];
	selectedOption: ICGIOption;
	type: QuestionType;
	updatedAt: Date;
	radioValue?: { optionId: number; questionId: number };
}

export interface CGIBaselineAnswer {
	type: QuestionType;
	selectedOption: ICGIOption;
}

interface cgiOption {
	id: number;
	level?: number;
	levelDescription?: string;
}

export interface ICGIOption {
	level: number;
	levelDescription: string;
}

export enum QuestionType {
	CGI = 'cgi',
	LIFE_QUALITY = 'life_quality',
}

export interface ICGILevel {
	level: number;
	levelDescription: string;
}
